module.exports = __webpack_public_path__ + "img/ggpoker.1bdfb4f8.png";